import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ContactsWorkspaceStateService } from './contacts-workspace-state.service';

/** A mounted Groups rail's list state follows that row, including when its area is inactive. */
@Injectable()
export class ContactsRowStateService extends ContactsWorkspaceStateService {
  private readonly rowOwner = new BehaviorSubject<string | null | undefined>(undefined);

  public bindOwner(owner: string | null): void {
    this.rowOwner.next(owner);
  }

  protected override workspaceOwner(): string | null | undefined {
    return this.rowOwner.value === undefined ? super.workspaceOwner() : this.rowOwner.value;
  }

  protected override ownerChanges(): Observable<string | null> {
    return this.rowOwner.asObservable() as Observable<string | null>;
  }
}
